import { formatDateRange } from './formatDateRange'
import ProposalMainDetails from './proposal-main-details'

export { formatDateRange, ProposalMainDetails }
